import { t } from "i18next";
import { breakpointSize } from "../../../theme/mediaQuerie";
import Button from "../../shared/button/Button";
import Input from "../../shared/input/Input";
import Typography from "../../shared/typography/Typography";
import { Subtitle } from "../Subtitle";
import { CardContainer, CardWrapper, ModalContent, TitleContainer } from "./style";

interface IProps {
  name: string;
  setName: React.Dispatch<string>;
  type: 'event' | 'university' | "video-conference" | '';
  setType: React.Dispatch<'event' | 'university' | "video-conference" | ''>;
  handleCreate: () => void;
}

const isMobile = window.innerWidth <= breakpointSize.Sm;

export const NewWlModalContent = ({ name, setName, type, setType, handleCreate }: IProps) => (
  <ModalContent>
    <header>
      <div>
        <Typography type={isMobile ? "heading5" : "heading4"}>{t("dashboard.modal.createWL.title")}</Typography>
        <Typography type="paragraphXS">{t("dashboard.modal.createWL.text")}</Typography>
        {isMobile && (
          <div style={{ display: 'flex', gap: '16px', width: '100%' }}>
            <Button
              onClick={() => setType('university')}
              rounded size="medium"
              backgroundActive="primaryDark"
              colorFont="white"
              typographyType={isMobile ? "headingXXXS" : "headingXS"}
              colorBackground={type === 'university' ? 'primary' : 'line'}
              fullWidth
              enable
            >
              {t("wl.type.university")}
            </Button>
            <Button
              onClick={() => setType('video-conference')}
              rounded size="medium"
              backgroundActive="primaryDark"
              colorFont="white"
              typographyType={isMobile ? "headingXXXS" : "headingXS"}
              fullWidth
              colorBackground={type === 'video-conference' ? 'primary' : 'line'}
              enable
            >
              {t("wl.type.conference")}
            </Button>
          </div>
        )}
      </div>
      {!isMobile && (
        <Button
          onClick={handleCreate}
          rounded size="medium"
          backgroundActive="primaryDark"
          colorFont="white"
          typographyType="headingXS"
          enable={name.trim() !== ""}
        >
          {t("proceed")}
        </Button>
      )}
    </header>
    <CardWrapper>
      <CardContainer onClick={() => setType('university')} selected={type === 'university'}>
        <svg width="253" height="185" viewBox="0 0 253 185" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1776_14238)">
            <rect x="0.25" y="0.499512" width="252" height="184" rx="8" fill="white" />
            <rect x="16.25" y="17.4995" width="220" height="72" rx="8" fill="#FF3655" />
            <rect x="16.25" y="101.5" width="168" height="14" rx="7" fill="#D6D8E7" />
            <rect x="196.25" y="101.5" width="14" height="14" rx="7" fill="#D6D8E7" />
            <rect x="222.25" y="101.5" width="14" height="14" rx="7" fill="#D6D8E7" />
            <rect x="16.25" y="127.5" width="40" height="40" rx="8" fill="#A0A3BD" />
            <rect x="68.25" y="127.5" width="40" height="40" rx="8" fill="#A0A3BD" />
            <rect x="120.25" y="127.5" width="40" height="40" rx="8" fill="#A0A3BD" />
            <rect x="172.25" y="127.5" width="40" height="40" rx="8" fill="#A0A3BD" />
            <rect x="224.25" y="127.5" width="40" height="40" rx="8" fill="#A0A3BD" />
          </g>
          <rect x="0.75" y="0.999512" width="251" height="183" rx="7.5" stroke="#D6D8E7" />
          <defs>
            <clipPath id="clip0_1776_14238">
              <rect x="0.25" y="0.499512" width="252" height="184" rx="8" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <div>
          {!isMobile && <Typography type="headingXL">{t("wl.type.university")}</Typography>}
          <Typography type="paragraphXS">{t("createWhitelabel.text")}</Typography>
        </div>
      </CardContainer>
      {/* <CardContainer onClick={() => setType('event')} selected={type === 'event'}>
        <svg width="253" height="185" viewBox="0 0 253 185" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1776_14254)">
            <rect x="0.75" y="0.499512" width="252" height="184" rx="8" fill="white" />
            <rect x="-7.75" y="0.499512" width="269" height="72" fill="#FF3655" />
            <rect x="12.75" y="84.4995" width="228" height="57" rx="8" fill="#A0A3BD" />
            <rect x="12.75" y="153.5" width="228" height="11" rx="5.5" fill="#D6D8E7" />
            <rect x="12.75" y="168.5" width="228" height="11" rx="5.5" fill="#D6D8E7" />
            <rect x="12.75" y="183.5" width="228" height="11" rx="5.5" fill="#D6D8E7" />
          </g>
          <rect x="1.25" y="0.999512" width="251" height="183" rx="7.5" stroke="#D6D8E7" />
          <defs>
            <clipPath id="clip0_1776_14254">
              <rect x="0.75" y="0.499512" width="252" height="184" rx="8" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <div>
          {!isMobile && <Typography type="headingXL">{t("wl.type.event")}</Typography>}
          <Typography type="paragraphXS">{t("createWhitelabel.text")}</Typography>
        </div>
      </CardContainer> */}
      <CardContainer onClick={() => setType('video-conference')} selected={type === 'video-conference'}>
        <svg width="253" height="185" viewBox="0 0 253 185" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.75" y="1.00098" width="251" height="183" rx="7.5" fill="white" />
          <rect x="0.75" y="1.00098" width="251" height="183" rx="7.5" stroke="#D6D8E7" />
          <rect x="16.25" y="16.501" width="145" height="133" rx="8" fill="#FF3655" />
          <path d="M102 83.5L81.75 95.1913L81.75 71.8087L102 83.5Z" fill="white" />
          <rect x="16.25" y="161.501" width="145" height="7" rx="3.5" fill="#A0A3BD" />
          <rect x="173.25" y="16.501" width="63" height="70" rx="8" fill="#A0A3BD" />
          <rect x="173.25" y="98.501" width="63" height="70" rx="8" fill="#A0A3BD" />
        </svg>

        <div>
          {!isMobile && <Typography type="headingXL">{t("wl.type.conference")}</Typography>}
          <Typography type="paragraphXS">{t("createConferencelabel.text")}</Typography>
        </div>
      </CardContainer>
    </CardWrapper>
    {type !== "" && (
      <TitleContainer>
        <Subtitle>{t("title")}</Subtitle>
        <Input
          value={name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
        />
      </TitleContainer>
    )}
  </ModalContent>
)